<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2022-05-17 20:31:57
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-05-17 20:32:23
-->
<template>
  <router-view />
</template>

<script>
export default {
  name: "CooperativeTrustee",
};
</script>
